
/* eslint-disable no-param-reassign */
import { AUTOFILL_LOOKUP_ALLOWED_FIELDS, ControlType, getCountriesList } from '../../../shared/form-lib';
import { checkCalculation, checkLogic } from '../../../shared/utils';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { isValidTimeString } from '../utils';

export const fakeUpdateValueForRowContainers = (pages, calculations, rules) => {
  const demoValue = Math.random().toString(36).slice(2, 7);
  pages.forEach((page) =>
    page.controls.forEach((ctrl) => {
      // Detect row
      // Check if involved in calculations or logic
      if (ctrl.type === 'add_row' && (checkCalculation(calculations, ctrl).length || checkLogic(rules, ctrl).length)) {
        ctrl.value = demoValue;
        return ctrl;
      }
    })
  );
};

export const assignAutofillValues = (autoFillValues, control) => {
  const {
    CHECKBOX,
    CHECKBOXES,
    INLINE_CHECKBOXES,
    RADIO,
    RADIO_BUTTONS,
    INLINE_RADIOS,
    SELECT_MULTIPLE,
    SCALE_RATING,
    HEART_RATING,
    STAR_RATING,
    SMILEY_RATING,
    COUNTRY,
    NUMBER,
    PHONE,
    DATETIME,
    SELECT_BASIC,
    ADDRESS,
  } = ControlType;
  const fieldType = control.type;
  const heartsCount = control.props.hearts_count;
  const starsCount = control.props.stars_count;
  const autoFillValue = autoFillValues[control.internal_id];
  if (autoFillValue && !(/^\s*$/.test(autoFillValue)) && AUTOFILL_LOOKUP_ALLOWED_FIELDS[fieldType]) {
    if (fieldType === SELECT_MULTIPLE) {
      const newValue = autoFillValue.split('\n');
      if (newValue.length) {
        control.props.options = newValue;
        control.value = newValue;
      } 
    } else if ([CHECKBOX, CHECKBOXES, INLINE_CHECKBOXES].includes(fieldType)) {
      const newValue = autoFillValue.split('\n');
      if (newValue.length) {
        control.props.options = newValue;
        const assignableValue = {};
        for (const value of newValue) {
          assignableValue[value] = true;
        }
        control.value = assignableValue;
      }
    } else if ([RADIO, RADIO_BUTTONS, INLINE_RADIOS, SELECT_BASIC].includes(fieldType)) {
      control.props.options = [autoFillValue];
      control.value = autoFillValue;
    } else if (fieldType === SCALE_RATING) {
      // sampleValue = 'Option 2'
      const splitValue = autoFillValue.split(' ');
      const [unitPart, numberPart] = splitValue;
      if (splitValue.length === 2 && unitPart === 'Option' && !isNaN(numberPart)) {
        control.value = autoFillValue;
      }
    } else if (fieldType === HEART_RATING) {
      // sampleValue = '4 Hearts'
      const splitValue = autoFillValue.split(' ');
      const [numberPart, unitPart] = splitValue;
      if (splitValue.length === 2 && unitPart === 'Hearts' && !isNaN(numberPart) && numberPart <= heartsCount) {
        control.value = autoFillValue;
      }
    } else if (fieldType === STAR_RATING) {
      // sampleValue = '4 Stars'
      const splitValue = autoFillValue.split(' ');
      const [numberPart, unitPart] = splitValue;
      if (splitValue.length === 2 && unitPart === 'Stars' && !isNaN(numberPart) && numberPart <= starsCount) {
        control.value = autoFillValue;
      }
    } else if (fieldType === SMILEY_RATING) {
      // sampleValue = 'Amazing'
      const smileyOptionTypes = ['Angry', 'Sad', 'Neutral', 'Happy', 'Amazing'];
      if (smileyOptionTypes.includes(autoFillValue)) {
        control.value = autoFillValue;
      }
    } else if (fieldType === COUNTRY) {
      const allCountries = getCountriesList().map((ct) => ct.name);
      if (allCountries.includes(autoFillValue)) {
        control.value = autoFillValue;
      }
    } else if (fieldType === NUMBER) {
      if (!isNaN(autoFillValue)) {
        control.value = autoFillValue;
      }
    } else if (fieldType === PHONE) {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const isValidPhone = () => {
        try {
          return phoneUtil.isValidNumber(phoneUtil.parse(`+${autoFillValue}`));
        } catch (error) {
          return false;
        }
      };

      if (isValidPhone()) {
        control.value = autoFillValue;
      }
    } else if (fieldType === ADDRESS) {
      const addressObj = JSON.parse(autoFillValue);
      if (addressObj instanceof Object) {
        control.value = addressObj;
      }
    } else if (fieldType === DATETIME) {
      const isDate = !isNaN(new Date(autoFillValue));
      const isTime = isValidTimeString(autoFillValue);
      if (isDate || isTime) {
        control.value = autoFillValue;
      }
    } else {
      control.value = autoFillValue;
    }
  }
};
